import React, { useEffect, useState } from "react"
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import UpdateTable from "../../../components/Common/UpdatedTable"
import {
  downloadAccGroupSummary,
  downloadDayBook,
  fetchFinanceGroupSummary,
} from "../../../services/finance/finance"
import moment from "moment"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import closeIcon from "../../../assets/icons/close.svg"
import NumberFormat from "../../../utils/numberFormat"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
// import GroupSummaryFilter from "./filter"
import { toastError } from "../../../helpers/msg_helper"
import arrow from "../../../assets/icons/arrow.svg"
import { set } from "lodash"

const MonthlyGroupReport = ({ fromDashboard }) => {
  const location = useLocation()

  console.log(`location`, location)

  const { id } = useParams()

  const pathName = location?.state?.item?.group_name ?? ""

  console.log(`location?.state`, location?.state)

  const companyname = localStorage.getItem("companyname")
  document.title = `${pathName || "Account Book"}${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  console.log(`desimalrange`, desimalrange)

  const navigate = useNavigate()
  const [search, setSearch] = useState("")
  const [page, setPage] = useState(1)
  const [fetchedData, setFetchedData] = useState()
  const [groupedData, setGroupData] = useState()
  const [dateFrom, setDatefrom] = useState(
    moment().startOf("year").format("YYYY-MM-DD")
  )
  const [dateTo, setDateto] = useState(
    moment().endOf("year").format("YYYY-MM-DD")
  )
  const [acc, setAcc] = useState(
    pathName == "Cash-in-Hand"
      ? [6]
      : pathName == "Bank Account"
      ? [5]
      : pathName == "Bank OD & OCC Account"
      ? [15]
      : pathName == "Purchase Account"
      ? [29]
      : pathName == "Sales Account"
      ? [26]
      : 0
  )

  console.log(`acc`, acc)

  const [viewData, setViewData] = useState()
  const [modal, setModal] = useState(false)
  const [dataPerPage, setDataPerPage] = useState(1000)

  const [summary, setSummary] = useState({
    totalDebit: 0,
    totalCredit: 0,
    closingBalance: 0,
    closingType: "Dr",
  })

  const toggle = () => setModal(!modal)

  const [voucherTypeId, setVoucherTypeId] = useState("")

  useEffect(() => {
    setAcc(
      pathName == "Cash-in-Hand"
        ? [6]
        : pathName == "Bank Account"
        ? [5]
        : pathName == "Bank OD & OCC Account"
        ? [15]
        : pathName == "Purchase Account"
        ? [29]
        : pathName == "Sales Account"
        ? [26]
        : 0
    )
    setDatefrom(
      location?.state?.startDate ??
        moment().startOf("year").format("YYYY-MM-DD")
    )
    setDateto(
      location?.state?.endDate ?? moment().endOf("year").format("YYYY-MM-DD")
    )
    setPage(1)
  }, [pathName])

  const calculateSummary = (monthly_summary = []) => {
    let totalDebit = 0
    let totalCredit = 0

    monthly_summary.forEach(item => {
      totalDebit += item.net_debit || 0
      totalCredit += item.net_credit || 0
    })

    const closingBalance = Math.abs(totalDebit - totalCredit)
    const closingType = totalDebit > totalCredit ? "debit" : "credit"

    return { totalDebit, totalCredit, closingBalance, closingType }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responce = await fetchFinanceGroupSummary({
          params: `${`monthly_summary=true`}${
            search ? `&searchText=${search}` : "&searchText"
          }${page ? `&page=${page}` : ""}${
            acc && acc.length ? acc.map(id => `&group_id[]=${id}`).join("") : ""
          }${
            location?.state?.item?.ledger_id
              ? `&ledger_id=${location?.state?.item?.ledger_id}`
              : ""
          }${
            dateFrom
              ? `&start_date=${dateFrom}`
              : `&start_date=${moment().startOf("year").format("YYYY-MM-DD")}`
          }${
            dateTo
              ? `&end_date=${dateTo}`
              : `&end_date=${moment().endOf("year").format("YYYY-MM-DD")}`
          }`,
        })

        const result = calculateSummary(responce?.monthly_summary || [])
        setSummary(result)

        setFetchedData(responce)
      } catch (err) {
        toastError(err?.message)
        setFetchedData(null)
        // setGroupData([])
        // ${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}
      }
    }
    if (id && acc != undefined && acc !== "" && acc !== 0) {
      fetchData()
    }
  }, [
    page,
    search,
    location,
    dateFrom,
    dateTo,
    voucherTypeId,
    dataPerPage,
    acc,
    id,
  ])
  const handleVoucherTypeChange = id => {
    setVoucherTypeId(id)
    setPage(1)
  }

  // ${dateFrom ? `&start_date=${dateFrom}` : ""}${
  //   dateTo ? `&end_date=${dateTo}` : ""
  // }

  const handleView = item => {
    setViewData(item)
    toggle()
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const handleScroll = e => {
    console.log("scroll event fired", e.target.scrollTop)
    const { scrollTop, scrollHeight, clientHeight } = e.target

    console.log(
      `scrollTop, scrollHeight, clientHeight`,
      e,
      scrollTop,
      scrollHeight,
      clientHeight
    )

    if (scrollHeight - scrollTop <= clientHeight + 50) {
      // near bottom
      if (page < fetchedData?.last_page) {
        setPage(prev => prev + 1)
      }
    }
  }

  const columns = [
    {
      label: "Particulars",
      renderCell: item => (
        <div
          onClick={() =>
            navigate(`/finance-ledger-acc`, {
              state: {
                item,
                startDate: moment(`${item?.year}-${item?.month}`, "YYYY-MMMM")
                  .startOf("month")
                  .format("YYYY-MM-DD"),
                endDate: moment(`${item?.year}-${item?.month}`, "YYYY-MMMM")
                  .endOf("month")
                  .format("YYYY-MM-DD"),
                ledger_id: id,
                ledger_name: location?.state?.item?.ledger_name,
              },
            })
          }
          className="pointer fw-bold"
        >
          {item?.month} ({item?.year})
        </div>
      ),
    },

    {
      label: <div className="text-end pe-3">Opening Balance (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-3">
          {NumberFormat(item?.opening_balance, desimalrange, desimalrange)}{" "}
          {item?.opening_balance_type == "credit" ? "Cr" : "Dr"}
        </div>
      ),
    },

    {
      label: <div className="text-end pe-5">Debit (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(item?.net_debit, desimalrange, desimalrange)}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Credit (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(item?.net_credit, desimalrange, desimalrange)}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-3">Closing Balance (AED)</div>,
      renderCell: item => (
        <div
          className={`text-end pe-3 ${
            item?.closing_type === "credit" ? "text-danger" : ""
          }`}
        >
          {NumberFormat(item?.net_balance, desimalrange, desimalrange)}{" "}
          {item?.closing_type == "credit" ? "Cr" : "Dr"}
        </div>
      ),
    },
  ]
  const viewColumn = [
    {
      label: "Group Name",
      renderCell: item => (
        <div
          onClick={() =>
            navigate(`/finance-ledger-acc`, {
              state: item,
            })
          }
          className="pointer fw-bold fs-13 ps-2"
        >
          {item?.ledger_name}
          <span className="ps-1">
            <img src={arrow} alt="" width="7" />
          </span>
        </div>
      ),
    },
    {
      label: "Amount",
      label: "Amount",
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(Number(item?.currentDebit), desimalrange, desimalrange)}
          AED
        </div>
      ),
    },
    {
      label: "Amount",
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.currentCredit),
            desimalrange,
            desimalrange
          )}{" "}
          AED
        </div>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }

  const handleAccChange = data => {
    setAcc([data])
    setPage(1)
  }
  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <>
                <Breadcrumbs
                  title="Finance"
                  breadcrumbObject={[
                    { title: "Finance", link: "/finance" },
                    { title: "Account Book", link: "/finance" },
                    { title: pathName, link: "" },
                  ]}
                />
              </>
            ) : (
              <></>
            )}
            {/* <>
              <div className="me-2">
                <span
                  id={`PopoverLegacy-1`}
                  className="px-2 mb-3 btn btn-primary"
                >
                  Download
                </span>
              </div>
              <UncontrolledPopover
                placement="bottom"
                target={`PopoverLegacy-1`}
                trigger="legacy"
              >
                <PopoverBody>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadAccGroupSummary({
                        params: `${`monthly_summary=true`}${
                          search ? `&searchText=${search}` : "&searchText"
                        }${page ? `&page=${page}` : ""}${
                          acc && acc.length
                            ? acc.map(id => `&group_id[]=${id}`).join("")
                            : ""
                        }${
                          location?.state?.item?.ledger_id
                            ? `&ledger_id=${location?.state?.item?.ledger_id}`
                            : ""
                        }${
                          dateFrom
                            ? `&start_date=${dateFrom}`
                            : `&start_date=${moment()
                                .startOf("year")
                                .format("YYYY-MM-DD")}`
                        }${
                          dateTo
                            ? `&end_date=${dateTo}`
                            : `&end_date=${moment()
                                .endOf("year")
                                .format("YYYY-MM-DD")}`
                        }${"&download=pdf"}`,
                        type: "pdf",
                        fileName: `${pathName}.pdf`,
                      })
                    }
                  >
                    PDF
                  </div>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadAccGroupSummary({
                        params: `${`monthly_summary=true`}${
                          search ? `&searchText=${search}` : "&searchText"
                        }${page ? `&page=${page}` : ""}${
                          acc && acc.length
                            ? acc.map(id => `&group_id[]=${id}`).join("")
                            : ""
                        }${
                          location?.state?.item?.ledger_id
                            ? `&ledger_id=${location?.state?.item?.ledger_id}`
                            : ""
                        }${
                          dateFrom
                            ? `&start_date=${dateFrom}`
                            : `&start_date=${moment()
                                .startOf("year")
                                .format("YYYY-MM-DD")}`
                        }${
                          dateTo
                            ? `&end_date=${dateTo}`
                            : `&end_date=${moment()
                                .endOf("year")
                                .format("YYYY-MM-DD")}`
                        }${"&download=excel"}`,
                        type: "excel",
                        fileName: `${pathName}.xlsx`,
                      })
                    }
                  >
                    Excel
                  </div>
                </PopoverBody>
              </UncontrolledPopover>
            </> */}
          </div>
          <Card
            className={`me-2 px-2 pb-2 ${
              fromDashboard ? "dash-table-bg ps-0 pb-0 finance-table-nav" : ""
            }`}
          >
            {/* {!fromDashboard ? (
              <>
                <GroupSummaryFilter
                  handleSearchChange={handleSearchChange}
                  handleDateChange={handleDateChange}
                  handleAccChange={handleAccChange}
                  isImport={false}
                  isGroup={pathName == "Group Summary" ? true : false}
                  //   handleVoucherTypeChange={handleVoucherTypeChange}
                />
                <hr className="table-divide" />
              </>
            ) : (
              <div></div>
            )} */}
            {fetchedData?.monthly_summary?.length ? (
              <Row className="mt-2 ever-rise-table accTable">
                <Col
                  xs={12}
                  // className="vh-60"
                >
                  <div
                    className="scrollable-table-container"
                    style={{ height: "74vh", overflowY: "auto" }}
                    onScroll={handleScroll}
                  >
                    {fetchedData?.monthly_summary?.length && (
                      <UpdateTable
                        className="mt-5"
                        nodes={fetchedData?.monthly_summary}
                        // paginate={fetchedData}
                        CurrentPage={page}
                        columns={columns}
                        subColumn={viewColumn}
                        subName={"ledgers"}
                        subHeader={false}
                        expand={true}
                        handlePagination={handlePaginate}
                        // handleSizePerPage={handleSizePerPageChange}
                        // hidePaginate={true}
                        tableWidth="30% 20% 15% 15% 20%"
                        mobileWidth="80% 40% 40% 40% 40%"
                      />
                    )}
                  </div>
                </Col>
                {/* <div className="d-flex mt-2 fw-bold">
                  <div className="w-40">Grand Total</div>
                  <div className="text-end pe-5 w-20">
                    {NumberFormat(
                      Math.abs(Number(summary?.totalDebit || 0)),
                      desimalrange,
                      desimalrange
                    )}
                  </div>
                  <div className="text-end pe-5 w-20">
                    {NumberFormat(
                      Math.abs(Number(summary?.totalCredit || 0)),
                      desimalrange,
                      desimalrange
                    )}
                  </div>
                  <div className="text-end pe-3 w-20">
                    {NumberFormat(
                      Math.abs(Number(summary?.closingBalance || 0)),
                      desimalrange,
                      desimalrange
                    )}{" "}
                    {summary?.closingType == "credit" ? "Cr" : "Dr"}
                  </div>
                </div> */}
              </Row>
            ) : (
              <div className="d-flex justify-content-center pt-5">
                {pathName == "Group Summary" ? "Please Select Group" : ""}
              </div>
            )}
          </Card>
        </div>
      </div>
      {/* <Modal isOpen={modal} toggle={toggle} size="lg" unmountOnClose={false}>
        <>
          <ModalHeader className="custom-modal-header">
            <div className="d-flex justify-content-between">
              <h5 className="ms-2">Details</h5>
              <img
                src={closeIcon}
                alt=""
                onClick={toggle}
                width="10"
                role="button"
              />
            </div>
          </ModalHeader>
          <ModalBody>
            <Row className="mt-2 ever-rise-table accTable">
              <Col xs={12}>
                {viewData?.journal_entry_details && (
                  <UpdateTable
                    className="mt-5"
                    nodes={viewData?.journal_entry_details}
                    columns={viewColumn}
                    handilpagedrop={false}
                    tableWidth="20% 20% 20% 20% 20%"
                    mobileWidth="40% 40% 40% 40% 40%"
                  />
                )}
              </Col>
            </Row>
          </ModalBody>
        </>
      </Modal> */}
    </React.Fragment>
  )
}

export default MonthlyGroupReport
